// extracted by mini-css-extract-plugin
module.exports = {"container":"NoCompanyFound_container__1APzo","card":"NoCompanyFound_card__1V8Pu","buttonContainer":"NoCompanyFound_buttonContainer__1Z5YM"};